;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { PageStoryblok } from '@qogita/cms'
import { ReactNode } from 'react'
import { Footer } from 'src/deprecated/components/shared/Footer'
import { TopBar } from 'src/deprecated/components/shared/TopBar'
import { UserProvider } from 'src/deprecated/contexts/User'

type PublicLayoutProps = {
  children: ReactNode
  pageBlok: PageStoryblok | null
}

export const PublicLayout = ({ children, pageBlok }: PublicLayoutProps) => {
  return (
    <UserProvider>
      <div className="flex min-h-screen flex-col">
        <TopBar />
        <main className="flex grow flex-col">{children}</main>
        <Footer pageBlok={pageBlok} />
      </div>
    </UserProvider>
  )
}
